import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="font-heading text-2xl text-foreground-900 whitespace-nowrap">
              韩漫大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-500 ${
                location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-500 ${
                  location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-700'
                }`}
              >
                分类浏览
                <i className={`${categoryOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-lg transition-transform`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 bg-background-50 border border-background-200/70 rounded-lg shadow-lg py-2 min-w-[200px] z-50">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.id}`}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-secondary-100 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap"
                    >
                      <i className={`${cat.icon} mr-2`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-500 ${
                location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200/70 rounded-full focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-400/20 w-48 transition-all duration-200"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            aria-label="打开菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-4 px-4">
            <div className="flex flex-col gap-3">
              <Link
                to="/"
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap"
              >
                首页
              </Link>
              <div>
                <button
                  onClick={() => setCategoryOpen(!categoryOpen)}
                  className="flex items-center justify-between w-full text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap"
                >
                  分类浏览
                  <i className={`${categoryOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-lg`}></i>
                </button>
                {categoryOpen && (
                  <div className="pl-4 mt-1 space-y-1">
                    {categories.map((cat) => (
                      <Link
                        key={cat.id}
                        to={`/category/${cat.id}`}
                        className="block text-sm text-foreground-600 hover:text-primary-500 py-1.5 whitespace-nowrap"
                      >
                        <i className={`${cat.icon} mr-2`}></i>{cat.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
              <Link
                to="/about"
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap"
              >
                关于我们
              </Link>
              <div className="relative mt-2">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-full pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200/70 rounded-full focus:outline-none focus:border-primary-300"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}